import React from 'react';
import { Layout } from 'antd';
import cx from 'classnames';
import { CopyrightOutlined } from '@ant-design/icons';
// @ts-ignore
// import { FormattedMessage } from 'umi';
import styles from './index.less';
const curYear = new Date().getFullYear();
const Footer = ({ className }) => {
    return (React.createElement(Layout.Footer, { className: cx(styles.footerContainer, { [className]: !!className }) },
        React.createElement("div", null,
            "Copyright ",
            React.createElement(CopyrightOutlined, null),
            " ",
            curYear,
            " Envision Energy | Powered by Smart Web Platform")));
};
export default Footer;
